import {ErrorMessage, Field} from 'formik';
import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {EmpionTextField} from '../../../../../../../../../components/EmpionTextField/EmpionTextField';

export const HardFactsFieldsTitle = () => {
  const {t} = useTranslation();

  return (
    <Grid item xs={12} sm={12}>
      <Field
        type='text'
        name='title'
        label={`${t('companyJobPostings.newJobDialog.formLabels.title')}`}
        component={EmpionTextField}
        fullWidth
        required={true}
      />
      <Typography variant='body2' color='error'>
        <ErrorMessage name='title' component='span' />
      </Typography>
    </Grid>
  );
};
